import Model from '../model';
import { GET_CLOSEST_EVENT, GET_OPEN_EVENTS } from 'api/graphql/events';
import { parseShape, wrapPromise } from '../model/utils';
import { sanitize } from 'api/utils';

export const getClosestEvent = () => {
    return Model.apollo.query({
        query: GET_CLOSEST_EVENT
    }).then((response) => {
        const closestEvent = response?.['data']?.['openEvents']?.[0]?.startDate;
        if (closestEvent === undefined) {
            return {
                error: 'no closest date received'
            }
        }
        return {
            closestEvent
        };
    })
}

export const closestEventData = wrapPromise(getClosestEvent());

export const getOpenEvents = () => {
    return Model.apollo.query({
        query: GET_OPEN_EVENTS
    }).then((response) => {
        const parsed = parseShape(response)['data']['openEvents'];
        const fixedUTC = parsed.map(json => ({
            ...json,
            startDate: json.startDate.replace('+00:00','Z')
        }));
        Model.events.setLoadedEvents({ events: fixedUTC });
        return fixedUTC;
    }).catch((err) => {
        console.error(err);
    })
}

export const eventsData =  wrapPromise(getOpenEvents());

const types = {
    specialist: String,
    meeting: String,
    specialists: [String]
}
export const getSpecialistEvents = (variables) => {
    return Model.apollo.query({
        query: GET_OPEN_EVENTS,
        variables: sanitize(variables, types)
    }).then((response) => {
        const parsed = parseShape(response)['data']['openEvents'];
        const fixedUTC = parsed.map(json => ({
            ...json,
            startDate: json.startDate.replace('+00:00','Z')
        }))
        Model.events.setLoadedEvents({ events: fixedUTC })
        return fixedUTC;
    }).catch((err) => {
        console.error(err);
    })
}

export const specialistEventsData = (variables) => {
    const promise = getSpecialistEvents(variables);
    return wrapPromise(promise)
}
